(function () {
  'use strict';

  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      invest: {
        "signInvestment": "Potpiši investiciju",
        "headerNew": "Nova investicija",
        "accountFrom": "S računa",
        "amountInputLabel": "Iznos",
        "quantityInputLabel": "Količina",
        "accountTo": "Isplata na račun",
        "date":"Datum vrednovanja",
        "dateNewOrder":"Datum vrednovanja",
        "dueDate": "Datum vrednovanja",
        "amountPlaceholder": "eg. 1,000.00",
        "accountType": "Vrsta računa",
        "fundName": "Naziv fonda",
        "fundNameReplace": "Fond za zamjenu",
        "comment": "Napomena",

        "rulesCheckbox":"Prihvaćam Opće informacije i uvjete za pružanje investicijskih usluga i aktivnosti te pružanje pomoćnih usluga",
        "bellowComment":"Podnositelj Zahtjeva potvrđuje da je upoznat s",
        "bellowComment2_link1": "Općim informacijama i uvjetima za pružanje investicijskih usluga i aktivnosti te pružanje pomoćnih usluga",
        "bellowComment2_text": " kao i s ",
        "bellowComment2_link2": "Prospektom, Pravilima i Ključnim informacijama za ulagatelje fonda za koji podnosi Zahtjev",
        "bellowComment3": "  i da dokumente u cijelosti prihvaća.",
        "disclaimerText1": "Zahtjev za izdavanje/otkup udjela, kada je predan putem posrednika (Banke) predstavlja nalog u smislu Zakona o tržištu kapitala te Banka podnositelju zahtjeva (Klijent, Vi) pruža uslugu zaprimanja i prijenosa naloga u vezi s udjelom u UCITS pod-fondu iz ovog zahtjeva u skladu s uvjetima za pružanje te usluge u prilogu ovog zahtjeva i na web stranici Banke. Banka je dužna propisati i primjenjivati primjerene mjere i postupke koji omogućavaju promptno, ažurno i korektno izvršavanje naloga klijenta kao i druge mjere predviđene Zakonom o tržištu kapitala. U tu svrhu Banka je donijela Politiku izvršavanja naloga koja se nalazi u dokumentu u prilogu ovog zahtjeva te na web stranici Banke. Banka je dužna svoje klijente s obzirom na njihovo znanje, iskustvo, financijsku situaciju i ulagačke ciljeve, razvrstati na male i profesionalne ulagatelje. \n",
        "disclaimerText2": "Na temelju dostupnih podataka razvrstali smo Vas kao malog ulagatelja. ",
        "disclaimerText3": "Politika izvršavanja naloga primjenjuje se jednako na sve vrste ulagatelja te iako imate pravo na drugačije razvrstavanje, ono ne bi bilo od utjecaja na bilo koje Vaše pravo ili obvezu. Prije pružanja investicijske usluge dužni smo Vas upoznati sa određenim informacijama koje u bitnom uključuju informacije o Banci, financijskim instrumentima, vrstama i rizicima ulaganja u financijske instrumente, informacije u vezi sa zaštitom financijskih instrumenata ili novčanih sredstava klijenta uključivo rizicima koji proizlaze iz zbirnog držanja imovine. Sve navedene informacije kao i informacije o postupanju s pritužbama klijenata nalaze se u dokumentu u prilogu ovog zahtjeva i na web stranici Banke. Informacije o troškovima i povezanim naknadama koji proizlaze iz usluge ili transakcije dostavljaju se Klijentu u dokumentu u prilogu ovog zahtjeva i putem web stranice Banke. Klijent potpisom ovog zahtjeva potvrđuje da se Klijent obratio Banci sa zahtjevom za izdavanje/otkup udjela samoinicijativno i u vrijeme naznačeno na ovom zahtjevu te da isti predstavlja potpunu komunikaciju između Banke i Klijenta, te da je obaviješten da se sva komunikacija koja je dovela ili može dovesti do transakcije, tj. koja se odnosi na primitak, prijenos i izvršavanje naloga snima ili bilježi. Klijent je suglasan da primjerak ovog zahtjeva predstavlja potpuni zapis komunikacije Banke i Klijenta, a koji će biti dostupan na zahtjev u razdoblju od pet godina, te u razdoblju od sedam godina na zahtjev nadležnog tijela. Ukoliko je poznata e-mail adresa Klijenta i odabran je način komunikacije e-mailom, Klijent potpisom ovog zahtjeva potvrđuje da ima redovit pristup internetu kao i da mu je ponuđen izbor između informacija na papiru i drugog trajnog medija te daje izričito odobrenje Banci da mu se sve propisane informacije dostavlja putem web stranice Banke. Klijent potpisom ovog zahtjeva daje izričit pristanak na primanje svih propisanih informacija: o Banci i njenim uslugama za klijente, o financijskim instrumentima i povezanim rizicima, u vezi sa zaštitom financijskih instrumenata i novčanih sredstava klijenta, o troškovima i povezanim naknadama koji proizlaze iz usluge ili transakcije kao i svih izmjena navedenih dokumenata i informacija, putem trajnog medija na web stranici Banke. Klijent potpisom ovog zahtjeva daje izričitu suglasnost na Politiku izvršavanja naloga te pristaje da se svaka izmjena navedene politike objavljuje putem web stranice Banke.\n",
        "disclaimerText4": "",
        "disclaimerText5": "",
        "disclaimerText6": "",
        "disclaimerText7": "",
        "disclaimerText8": "",
        "disclaimerText9": "",

        "investor": "Investitor",
        "loan": "Kredit",
        "buyingFond": "Fond kupnje",
        "sellingFond": "Fond prodaje",
        "replacementFond": "Fond zamjene",
        "note": "Napomena",
        "back": "Natrag",
        "amountMinAmountError": "Pogrešan iznos ulaganja.",
        "amountMinAmountError2": "Minimalni iznos ulaganja za odabrani fond je 100,00 Kn.",
        "buyInvestmentPopup1": "Ovom transakcijom otvarate novi račun u fondu {{invFund}}",
        "buyInvestmentPopup2": "Da li želite nastaviti unos?",
        "add":"Potvrdi",
        "alertInfoNoFund": "Ne postoji investicija za odabrani račun.",
        "amountTypeAllShares": "Svi udjeli",
        "amountTypeShareValue": "Vrijednost udjela",
        "amountTypeShareQuantity": "Količina udjela",
        "accounts": "Računi",
        "info": "Za točnost podataka cijena udjela InterCapital fondova odgovoran je InterCapital Asset Management d.o.o.",
        "info1": "Za sve dodatne informacije molimo nazvati InterCapital Asset Management d.o.o. na tel: (01) 5540 821."
      },
      investOverview: {
        "totalShareValue": "Ukupna vrijednost udjela",
        "shareQuantity": " Količina udjela",
        "buyStocks": "Kupnja udjela",
        "sellStocks": "Prodaja udjela",
        "replaceStocks": "Zamjena udjela",
        "transactions": "Transakcije",
        "orders": "Nalozi",
        "sharedAccount": "Zajednički račun:",
        "invAmount": "Iznos investicije:",
        "invDate": "Datum investicije:",
        "buyAccount": "Korisnički račun:",
        "fundName": "Naziv fonda:",
        "noTransactionData": "Nema dostupnih transakcija.",
        "noOrderData": "Nema dostupnih naloga.",
        "shareAccount": "Račun udjela",
        "dateOfEntry": "Datum knjiženja",
        "shareValue": "Vrijednost udjela",
        "shareQuant": "Količina udjela",
        "chargeValue": "Vrijednost naknade",
        "fundType": "Vrsta fonda",
        "sharePrice": "Cijena udjela",
        "copyOrder": "Kopiraj nalog",
        "editOrder": "Promijeni nalog",
        "deleteOrder": "Izbriši nalog",
        "signOrder": "Potpiši nalog",
        "status_created": "Kreiran",
        "status_recalled": "Opozvan",
        "status_processed": "Obrađen",
        "status_rejected": "Odbijen",
        "status_closed": "Zatvoren",
        "status_signed": "Potpisan",
        "status_inProcess": "U Obradi",
        "status_canceled": "Storniran"
      },
      investmentsList: {
        invOverview: "Pregled investicijskih računa",
        "shareQuantity": "Količina dionica"
      },
      accessInvestment: {
        "accession": "Pristupnica investicijskom fondu",
        "nameSurname": "Ime i prezime",
        "address": "Adresa prebivališta",
        "identificationNumber": "Broj identifikacijske isprave",
        "issuer": "Izdavatelj",
        "phone": "Telefon",
        "emailNotification": "Slanje obavijesti E-mailom",
        "bank": "Banka",
        "paymentAccNumber": "Broj računa",
        "plannedYearInvestment": "Planirane godišnje investicije",
        "fundsInvestment": "Sredstva za ulaganje ostvarena su od dohotka od",
        "msg1": "Potpisom ovog Upitnika potvrđujem da su u njemu navedeni podaci istiniti te ovlašćujem društvo InterCapital Invest d.d.(dalje Društvo) da provjeri sve ovdje navedene podatke." +
        " Osobno ću vas obavijestiti ukoliko dođe do promjena vezanih uz prije izjavljene podatke i detalje.",
        "msg2": "Potpisom ovog Upitnika dajem izričitu suglasnost Društvu da može poduzimati sve radnje vezano na obradu i razmjenu mojih osobnih podataka navedenih u ovom Upitniku, uključujući i podatak o matičnom broju građana, a što obuhvaća pravo Društva na prikupljanje, spremanje, snimanje, organiziranje, uvid i prijenos osobnih podataka u svrhu obavljanja redovitih poslova Društva.",
        "employee": "Zaposlenik",
        "firm": "Poduzetnik",
        "unemployed": "Nezaposlen",
        "retired": "Umirovljenik",
        "student": "Student",
        "rest": "Ostalo",
        "personalStatus": "Osobni status",
        "employer": "Vrsta poslodavaca",
        "privateSector": "Privatni sektor",
        "civileService": "Državna služba",
        "stateAuth": "Tjela državne/lokalne vlasti",
        "emplTrade": "Državna trgovačka društva",
        "vocation": "Zvanje",
        "profession": "Zanimanje",
        "invEmployment": "Nesamostalni rad",
        "invfreelancing": "Samostalna djelatnost",
        "invLegal": "Imovina i imovinska prava",
        "capital": "Kapital",
        "invInsured": "Osiguranje",
        "inv1": "Do 25.000,00 EUR",
        "inv2": "Do 50.000,00 EUR",
        "inv3": "Do 100.000,00 EUR",
        "inv4": "Više od 100.000,00 EUR",
        "accountNumberInput": "Broj računa za isplatu",
        "add": "Dodaj"
      },
      salesReplacementTranslation: {
        title: "Poslovanje sa investicijskim fondovima"
      }
    };

    $translateProvider
        .translations('hr', data);

  }
}());
